import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that resets scroll position to the top whenever the route changes.
 * This ensures that navigating to a new page (like a pet detail or profile)
 * doesn't keep the scroll position of the previous view.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
